"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRedo = exports.isUndo = void 0;

function isUndoRedo(evt, shift) {
  /* istanbul ignore next line */
  var code = evt.keyCode || evt.which;

  if (code !== 122 && code !== 90) {
    return false;
  } // mac


  if (evt.metaKey && shift && !evt.ctrlKey && !evt.altKey) {
    return true;
  } // windows


  if (evt.ctrlKey && shift && !evt.metaKey && !evt.altKey) {
    return true;
  }

  return false;
}

exports.isUndo = function (evt) {
  return isUndoRedo(evt, !evt.shiftKey);
};

exports.isRedo = function (evt) {
  return isUndoRedo(evt, evt.shiftKey);
};